import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { Download } from "lucide-react";

const logo = `${process.env.PUBLIC_URL || ""}/images/teras-alami-logo.png`;

const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const image = new window.Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("Gagal memuat gambar"));
    image.src = src;
  });

const QrisPaymentQr = ({ qrString, alt = "QRIS pembayaran" }) => {
  const [qrImage, setQrImage] = useState("");
  const [hasError, setHasError] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    let active = true;

    QRCode.toDataURL(qrString, {
      errorCorrectionLevel: "H",
      margin: 2,
      width: 880,
      color: {
        dark: "#000000",
        light: "#FFFFFF",
      },
    })
      .then((dataUrl) => {
        if (!active) return;
        setQrImage(dataUrl);
        setHasError(false);
      })
      .catch(() => {
        if (!active) return;
        setQrImage("");
        setHasError(true);
      });

    return () => {
      active = false;
    };
  }, [qrString]);

  const handleDownload = async () => {
    if (!qrImage || isDownloading) return;

    setIsDownloading(true);
    try {
      const [qrSource, logoSource] = await Promise.all([loadImage(qrImage), loadImage(logo)]);
      const canvas = document.createElement("canvas");
      const size = 1200;
      const outerPadding = 35;
      const qrPadding = 20;
      const qrInnerSize = size - outerPadding * 2 - qrPadding * 2;
      const qrOffset = outerPadding + qrPadding;
      const logoBackdropSize = 160;
      const logoSize = 100;
      const context = canvas.getContext("2d");

      canvas.width = size;
      canvas.height = size;
      if (!context) throw new Error("Canvas tidak tersedia");

      context.fillStyle = "#FFFFFF";
      context.fillRect(0, 0, size, size);
      context.drawImage(qrSource, qrOffset, qrOffset, qrInnerSize, qrInnerSize);

      const logoBackdropX = (size - logoBackdropSize) / 2;
      const logoBackdropY = (size - logoBackdropSize) / 2;
      const logoX = (size - logoSize) / 2;
      const logoY = (size - logoSize) / 2;

      context.fillStyle = "#FFFFFF";
      context.strokeStyle = "#E7E5E4";
      context.lineWidth = 4;
      context.beginPath();
      context.roundRect(logoBackdropX, logoBackdropY, logoBackdropSize, logoBackdropSize, 48);
      context.fill();
      context.stroke();
      context.drawImage(logoSource, logoX, logoY, logoSize, logoSize);

      const anchor = document.createElement("a");
      anchor.href = canvas.toDataURL("image/png");
      anchor.download = "qris-daporkoe.png";
      anchor.click();
    } finally {
      setIsDownloading(false);
    }
  };

  if (hasError) {
    return (
      <div className="rounded-2xl border border-rose-100 bg-rose-50 px-4 py-5 text-sm text-rose-700">
        QRIS tersedia, tetapi gambar QR gagal dibuat. Silakan refresh halaman atau gunakan metode lain.
      </div>
    );
  }

  if (!qrImage) {
    return (
      <div className="rounded-2xl border border-stone-200 bg-stone-50 px-4 py-5 text-center text-sm text-stone-500">
        Menyiapkan QR pembayaran...
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-md rounded-2xl border border-stone-200 bg-white p-4 shadow-sm">
      <div className="relative mx-auto aspect-square w-full overflow-hidden rounded-2xl border border-stone-200 bg-white p-5">
        <img src={qrImage} alt={alt} className="h-full w-full rounded-xl object-contain" />
        <div className="absolute left-1/2 top-1/2 flex h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-xl bg-white">
          <img src={logo} alt="Logo Daporkoe" className="h-10 w-10 object-contain" />
        </div>
      </div>
      <button
        type="button"
        onClick={handleDownload}
        disabled={isDownloading}
        className="mt-4 inline-flex h-12 w-full items-center justify-center rounded-xl border border-stone-200 bg-stone-50 text-sm font-semibold text-stone-800 transition hover:bg-stone-100 disabled:cursor-not-allowed disabled:opacity-60"
      >
        <Download className="mr-2 h-4 w-4" />
        {isDownloading ? "Menyiapkan file..." : "Download QRIS"}
      </button>
    </div>
  );
};

export default QrisPaymentQr;
